import { initInView } from "./helpers";

document.querySelectorAll('[data-block-layout="header"]').forEach($el => {
    import('../../../partials/layout/header/header' /* webpackChunkName: "/dist/js/header" */).then(({ default: init }) => init($el));
});

document.querySelectorAll('[data-js="carousel-latest-posts"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/carousel-latest-posts/carousel-latest-posts' /* webpackChunkName: "/dist/js/carousel-latest-posts" */).then(({ default: init }) => init($el));
    });
});

document.querySelectorAll('[data-js="carousel-advantages"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/carousel/carousel-advantages' /* webpackChunkName: "/dist/js/carousel-advantages" */).then(({ default: init }) => init($el));
    });
});

document.querySelectorAll('[data-js="carousel-testimonials"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/carousel-testimonials/carousel-testimonials' /* webpackChunkName: "/dist/js/carousel-testimonials" */).then(({ default: init }) => init($el));
    });
});

document.querySelectorAll('[data-block="gallery"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/gallery/gallery' /* webpackChunkName: "/dist/js/gallery" */).then(({ default: init }) => init($el));
    });
});

document.querySelectorAll('[data-block="gallery-grid"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/gallery-grid/gallery-grid' /* webpackChunkName: "/dist/js/gallery-grid" */).then(({ default: init }) => init($el));
    });
});

document.querySelectorAll('[data-fancybox]').forEach($el => {
    initInView($el).then(() => {
        import('./common/fancybox-image' /* webpackChunkName: "/dist/js/fancybox-image" */).then(({ default: init }) => init($el));
    });
});

document.querySelectorAll('[data-block="slider"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/slider/slider' /* webpackChunkName: "/dist/js/slider" */).then(({ default: init }) => init($el));
    });
});

document.querySelectorAll('[data-js="ask-question-sticky"]').forEach($el => {
    import('../../../partials/blocks/ask-question/ask-question' /* webpackChunkName: "/dist/js/ask-question" */).then(({ default: init }) => init($el));
});

document.querySelectorAll('[data-block="youtube-embed"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/youtube-embed/youtube-embed' /* webpackChunkName: "/dist/js/youtube-embed" */).then(({ default: init }) => init($el));
    });
});

document.querySelectorAll('[data-block="field-select-nice"] select').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/field-select-nice/field-select-nice' /* webpackChunkName: "/dist/js/field-select-nice" */).then(({ default: init }) => init($el));
    });
});
document.querySelectorAll('[data-block="calendly-widget"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/calendly-widget/calendly-widget' /* webpackChunkName: "/dist/js/calendly-widget" */).then(({ default: init }) => init($el));
    });
});

document.querySelectorAll('[data-block="language-picker"] select').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/language-picker/language-picker' /* webpackChunkName: "/dist/js/language-picker" */).then(({ default: init }) => init($el));
    });
});

document.querySelectorAll('[data-block="country-picker"] select').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/country-picker/country-picker' /* webpackChunkName: "/dist/js/country-picker" */).then(({ default: init }) => init($el));
    });
});
document.querySelectorAll('[data-block="form-question"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/form-question/form-question' /* webpackChunkName: "/dist/js/form-question" */).then(({ default: init }) => init($el));
    });
});
